export default __webpack_public_path__ + "static/media/service_astra_btn.31b53cdf.png";